import { QRCodeSVG } from 'qrcode.react';
import { CARD_W, CARD_H } from './cardSize';

export default function NavyGold({ data, style }) {
  const { groomName, brideName, date, time, venue, address, message: msg, qrValue } = data || {};

  return (
    <div
      className="inv-card"
      style={{
        width: CARD_W, height: CARD_H,
        background: 'linear-gradient(155deg, #0B132B, #1C2541)',
        border: '2px solid #D4AF37',
        borderRadius: 10,
        padding: '8mm 9mm',
        fontFamily: "'Georgia', 'Times New Roman', serif",
        color: '#F1E9D2',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {/* Inner gold frame */}
      <div style={{
        position: 'absolute', inset: '4mm',
        border: '1px solid #D4AF37', borderRadius: 6, pointerEvents: 'none', opacity: 0.6,
      }} />

      {/* Top emblem */}
      <div style={{ fontSize: 16, color: '#D4AF37', marginBottom: 4 }}>✦</div>

      <div style={{ fontSize: 8.5, letterSpacing: 4, textTransform: 'uppercase', color: '#D4AF37', marginBottom: 7, fontWeight: 600 }}>
        To'y marosimiga taklif
      </div>

      <div style={{ fontSize: 21, fontWeight: 700, color: '#FFFFFF', lineHeight: 1.25, textAlign: 'center', letterSpacing: 0.5 }}>
        {groomName || 'Kuyov'} <span style={{ fontSize: 15, color: '#D4AF37', margin: '0 6px' }}>&</span> {brideName || "Kelin"}
      </div>

      <div style={{ width: 70, height: 1.5, background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)', margin: '9px 0' }} />

      <div style={{ fontSize: 11, textAlign: 'center', lineHeight: 1.55, color: '#E4DCC4' }}>
        {date && <div style={{ fontWeight: 600, color: '#fff' }}>{date}</div>}
        {time && <div>Soat: {time}</div>}
        {venue && <div style={{ fontWeight: 600, color: '#D4AF37', marginTop: 2 }}>{venue}</div>}
        {address && <div style={{ fontSize: 9.5, opacity: 0.75 }}>{address}</div>}
      </div>

      {msg && (
        <div style={{ fontSize: 8.5, fontStyle: 'italic', textAlign: 'center', color: '#C9BFA0', marginTop: 6, maxWidth: '78%' }}>
          {msg}
        </div>
      )}

      {qrValue && (
        <div style={{ position: 'absolute', bottom: '5mm', right: '5mm', background: '#F1E9D2', padding: 4, borderRadius: 6 }}>
          <QRCodeSVG value={qrValue} size={42} level="M" fgColor="#0B132B" bgColor="transparent" />
        </div>
      )}
    </div>
  );
}
